import html2pdf from 'html2pdf.js';

export const exportHtmlToPdf = (element: HTMLElement, filename: string) => {

    const options = {
        margin: [0, 0.3] as [number, number],
        filename: filename,
        image: { type: "jpeg" as const, quality: 1 },
        html2canvas: {},
        jsPDF: {
            unit: "in",
            format: "letter",
            orientation: "portrait" as const,
        },
    };

    html2pdf().set(options).from(element).save();
};